<twino-application-wrapper>
    <header header></header>
    <footer footer></footer>
</twino-application-wrapper>
<netcard-modal-notifications></netcard-modal-notifications>
